import React, { Component, useState, useEffect } from "react";

import { connect } from "react-redux";

import "./styles.css";

import Header from "../../components/Header/index";

import ItemCart from "../../components/ItemCart/index";

import { Creators as CartCreator } from "../../store/ducks/cart";

import { Creators as ProductCreator } from "../../store/ducks/product";

import Currency from "../../utils/currency";

import {Html5QrcodeScanner, Html5Qrcode} from "html5-qrcode";

import { useRef } from "react";

import qs from 'query-string';

import {
  FaPlus,
  FaCheck,
  FaTimesCircle,
  FaTimes,
  // FaCamera,
} from "react-icons/fa";

import { toast } from "react-toastify";

import Popup from "reactjs-popup";
import { BsCameraFill } from "react-icons/bs";
import api from "../../services/api";
import SweetAlert from "sweetalert2-react";

import "sweetalert/dist/sweetalert.css";


class Cart extends Component {

  constructor(props) {
    super(props);

    window.scrollTo(0, 0);

    let empresa = localStorage.getItem("@comer-aqui/empresa");

    if (!empresa) {
      return;
    }

    localStorage.setItem("typeorder", this.props.cart.typeorder);

    empresa = JSON.parse(empresa);

    let tipoPadrao = localStorage.getItem("@comer-aqui/typeOrder");

    if (this.props.cart.typeorder === 1) {
      empresa.vlTaxaentrega = 0;
    }

    let local = null;

    let taxaDeServico = empresa.vlTaxaentrega;

    let tpProdutoUnico = false;
    let idImpressora = 0;

    this.state = {
      items: props.cart.items,
      showPopMesa: false,
      showPopQRCodeMesa: false,
      showPopAlert: true,
      empresa,
      taxaDeServico,
      local,
      show: false,
      onStartCam: false,
      existInVerificaimpressora: false,
      existProdutosConvencionais: false,
      disable: false,
      typeOrder: tipoPadrao,
      isButtonDisabled: false,
      tpProdutoUnico,
      idImpressora,
    };

    if (this.props.cart.codEmpresa) {
      if (this.props.cart.codEmpresa !== empresa.codEmpresa) {
        toast.error(
          "Ops! Ocorreu um erro inesperado. Por favor tente novamente!"
        );

        this.props.history.push(this.props.cart.empresa);
        return
      }
    }
    else {
      this.props.cart.codEmpresa = empresa.codEmpresa;
      this.props.cart.empresa = localStorage.getItem("@comer-aqui/empresaUrl");
    }
  }

  
  handleMoreItems = (e) => {
    this.props.removeProduct();
    e.preventDefault();

    let empresa = localStorage.getItem("@comer-aqui/empresa");

    if (!empresa) {
      return;
    }

    empresa = JSON.parse(empresa);

    console.log(this.props.cart.codEmpresa, empresa.codEmpresa)

    if (this.props.cart.codEmpresa !== empresa.codEmpresa) {
      this.props.history.push(this.props.cart.empresa);
      return;
    }

    if (this.props.cart.typeorder === 4) {
      let empresa = localStorage.getItem("@comer-aqui/empresaUrl");
      
      if (!empresa) {
        this.props.history.push("/home");
        return;
      }

      this.props.history.push(empresa);

      // this.props.history.push(`/?nomeEmpresa=` + 'gerence');
    } else if (
      this.props.cart.typeorder === 1 ||
      this.props.cart.typeorder === 5
    ) {
      // console.log('21 = /?id=' + localStorage.getItem('@comer-aqui/authorization'))
      //this.props.history.push('/?id=' + localStorage.getItem('@comer-aqui/authorization'));
      this.props.history.push(
        "/" +
        localStorage.getItem("@comer-aqui/empresaUrl") +
        "/?id=" +
        localStorage.getItem("@comer-aqui/authorization")
      );
      // console.log('22 = /?id=' + localStorage.getItem('@comer-aqui/empresaUrl/authorization'))
    }
  };

  getInfoOrder = (hash) => { 
    hash = hash.split("id="); 
    hash = hash[hash.length - 1];
    const numberOrder = parseInt(hash.substring(9, 10) + hash.substring(11, 12) + hash.substring(14, 15));
    return numberOrder;
  }

  handleQRScan = async (decodedText) => {
    let empresaString = localStorage.getItem("@comer-aqui/empresa");
    var empresa = JSON.parse(empresaString);
    var tpUtilizaqrcode = empresa.tpUtilizaqrcode;

    if (tpUtilizaqrcode == 2) {
      // Atualiza o estado do componente pai com o valor do código QR
      this.setState({ local: this.getInfoOrder(decodedText) }); 
    } else {
      let { cart } = this.props;
      cart.numberOrder = this.getInfoOrder(decodedText);
    }

    this.getInfoOrder(decodedText);
    console.log(decodedText);

    await this.camera.clear();
    this.handleFinalizeOrder();
  };

  onScanFailure = (error) => {
    // handle scan failure, usually better to ignore and keep scanning.
    // for example:
    //console.warn(`Code scan error = ${error}`);
  };

  handleFinalizeOrder = async () => {
    try {
      if (!this.props.cart.totalprice > 0) {
        toast.error(
          "Nenhum item encontrado, por favor adicione item ao seu carrinho!"
        );
        return;
      }

      let { empresa } = this.state;

      // if (empresa.situacao === 0) {
      //     return;
      // }

      if (this.props.cart.codEmpresa !== empresa.codEmpresa) {
        toast.error(
          "Ops! Ocorreu um erro inesperado. Por favor tente novamente!"
        );

        this.props.history.push(this.props.cart.empresa);

        return
      }

      // Cesar - 20/07/2022
      if (localStorage.getItem("@comer-aqui/typeOrder") === "MESA" || localStorage.getItem("@comer-aqui/typeOrder") === "COMANDA") {
        if (empresa.tpSituacaoqrcode) {
        } else {
          if (empresa.situacao === 0) {
            return;
          }
        }
      } else {
        if (empresa.situacao === 0) {
          return;
        }
      }

      let { cart } = this.props;

      if (localStorage.getItem("@comer-aqui/typeOrder") === "MESA" || localStorage.getItem("@comer-aqui/typeOrder") === "COMANDA") {
      } else {
        if (parseFloat(cart.totalprice) < parseFloat(empresa.vlPedidominimo)) {
          toast.error(
            `Soma total dos itens no carrinho abaixo do valor mínimo de ${Currency.formatterValue.format(
              empresa.vlPedidominimo
            )} aceito!`
          );
          return;
        }
      }

      for (const item of cart.items) {
        if (item.borda) {
          const borda = {
            id: item.borda.idProduto,
            descricao: item.borda.dsProduto,
            valor: item.borda.vlPreco,
          };

          delete item["borda"];
          item.product.borda = borda;
        }
      }

      if (this.props.cart.typeorder === 4) {
        this.props.history.push("/user", { items: this.state.items });
      } else if (
        parseInt(this.props.cart.typeorder) === 1 ||
        parseInt(this.props.cart.typeorder) === 5
      ) {
        //( - #Gabriel
        let objEmpresa = localStorage.getItem("@comer-aqui/empresa");
        objEmpresa = JSON.parse(objEmpresa);
        let idEmpresa = objEmpresa.codEmpresa;

        let params = {
          token: localStorage.getItem("tokenValido"),
          local: parseInt(this.state.local),
          codempresa: idEmpresa,
          ...this.props.cart,
        }; //)

        params.numberOrder = cart.numberOrder;

        // localStorage.removeItem("tokenValido")

        var newData = new Date();
        var horaPedido = newData.toString().substring(16, 21);

        localStorage.setItem("horapedido", horaPedido);

        try {
          await api.post(`/pedidos`, params, {
            //( - Gabriel - Trocado cart por params
            headers: {
              "Content-Type": "application/json",
            },
          });
        } catch (erro) {
          //
          console.log(erro);

          toast.error("Ocorreu erro na requisição, tente novamente: " + erro);
          this.setState({
            disable: false,
          });
          this.setState({
            isButtonDisabled: false,
          });

          return;
        }

        // console.log(response)

        // console.log("teste = ", '/' + localStorage.getItem('@comer-aqui/empresaUrl') + '/?id=' + localStorage.getItem('@comer-aqui/authorization'))
        // this.props.history.push('/?id=' + localStorage.getItem('@comer-aqui/authorization') + '&nomeEmpresa=' + localStorage.getItem('@comer-aqui/nomeEmpresa'));

        this.props.history.push(
          "/" +
          localStorage.getItem("@comer-aqui/empresaUrl") +
          "/?id=" +
          localStorage.getItem("@comer-aqui/authorization")
        );

        // Cesar - 11/10/22
        localStorage.setItem(
          "@comer-aqui/msgToast",
          "Pedido finalizado com sucesso!"
        );

        //localStorage.removeItem('@comer-aqui/authorization');
        //localStorage.removeItem('@comer-aqui/numberOrder');

        // toast.error("Ocorreu erro na requisição");

        this.props.checkOut();
      }
    } catch (error) {
      // console.log(error)
    }
  };

  verifyUtilizeQrcode = () => {
    if (!this.props.cart.totalprice > 0) {
      toast.error(
        "Nenhum item encontrado, por favor adicione item ao seu carrinho!"
      );
      return;
    }
    
    let empresaString = localStorage.getItem("@comer-aqui/empresa");
    var empresa = JSON.parse(empresaString);
    var tpUtilizaqrcode = empresa.tpUtilizaqrcode;

    if (this.state.existInVerificaimpressora && !this.state.existProdutosConvencionais) {
      for (let itemCart of this.props.cart.items) {
        itemCart.idImpressora = this.state.idImpressora;   //Manda pra impressora do caixa
      }
    }

    if (tpUtilizaqrcode === null || tpUtilizaqrcode === 0  || tpUtilizaqrcode === 4) {
      this.handleFinalizeOrder();
    } else if (tpUtilizaqrcode === 1 || tpUtilizaqrcode === 3) {
      this.setState({ showPopMesa: true });
    } else if (tpUtilizaqrcode === 2 || tpUtilizaqrcode === 5) {
      // this.handleFinalizeOrderByTable();
      this.setState({ showPopQRCodeMesa: true });
    }
  };

  verifyValueMesa = () => {
    this.setState({ showPopMesa: false });
    this.setState({ showPopQRCodeMesa: false });
    this.handleFinalizeOrder();
  };

  handleFinalizeOrderByTable = () => {
    if (this.props.cart.typeorder === 1 || this.props.cart.typeorder === 5) {
      if (
        this.state.existInVerificaimpressora && 
        this.state.existProdutosConvencionais &&
        !this.state.tpProdutoUnico
      ) {
        this.setState({ show: true });
      } else {
        this.setState({ show: false });

        if (this.state.typeOrder === "ENTREGA") {
          this.handleFinalizeOrder();
        } else {
          this.verifyUtilizeQrcode();
        }
      }
    } else {
      if (this.state.typeOrder === "ENTREGA") {
        this.handleFinalizeOrder();
      } else {
        this.verifyUtilizeQrcode();
      }
    }
    // this.setState({
    //   disable: true,
    // });
  };

  checkVerificaimpressora = async (item, e) => {
    let items = [];

    let checked = e.target.checked;

    for (let itemCart of this.props.cart.items) {
      if (itemCart.id === item.id) {
        if (checked) {
          itemCart.idImpressora = this.state.idImpressora;   //Manda pra impressora do caixa
        } else {
          itemCart.idImpressora = item.inVerificaimpressora; //Manda pra impressora do embalador
        }
      }
    } //)

    this.setState({ items });
  };

  onBackButtonEvent = (e) => {
    e.preventDefault();
  };

  componentDidMount() {
    window.onpopstate = this.onBackButtonEvent;

    console.log('total anterior: ', this.props.cart.totalprice);

    this.props.cart.subtotal = 0;

    let camera = {};

    let existInVerificaimpressora = false;

    //(Gabriel - 24/06/2022
    let existProdutosConvencionais = false;

    for (let item of this.props.cart.items) {
      if (!item.inVerificaimpressora) {
        existProdutosConvencionais = true;
      }

      this.props.cart.subtotal += item.product.total;
    } //)

    //console.log("props", this.props);

    //this.props.cart.totalprice = this.props.cart.subtotal + this.props.cart.aditional;

    console.log('subtotal calculado: ', this.props.cart.subtotal);
    //console.log('total calculado: ', this.props.cart.totalprice);

    //Gabriel - 24/06/2022 - Adicionado if para validar se é mesa e se existem produtos que não são bebidas
    if (localStorage.getItem("@comer-aqui/typeOrder") === "MESA") {
      if (localStorage.getItem("@comer-aqui/idImpressora") !== undefined) {
        let idImp = parseInt(localStorage.getItem("@comer-aqui/idImpressora"));

        this.setState({ idImpressora: idImp });

        for (let item of this.props.cart.items) {
          if (item.inVerificaimpressora) {
            existInVerificaimpressora = true;
            item.idImpressora = item.inVerificaimpressora;
          }
        }
      }
    }

    // console.log("typeOrder", localStorage.getItem('@comer-aqui/typeOrder'));
    // console.log("existInVerificaimpressora", existInVerificaimpressora);

    this.setState({ existInVerificaimpressora });
    this.setState({ existProdutosConvencionais });
  }

  abrirCamera = async () => {
    this.setState({ onStartCam: true });
    const devices = await Html5Qrcode.getCameras();

    setTimeout(() => {
      if (!devices.length) {
        alert("Nenhuma câmera encontrada");
        return;
      }

      // procura câmera traseira
      const backCamera = devices.find(device => {

        const label = device.label.toLowerCase();

        return (
          label.includes("back") ||
          label.includes("rear") ||
          label.includes("traseira") ||
          label.includes("environment")
        );

      });

      // usa traseira se existir
      const cameraId = backCamera
        ? backCamera.id
        : devices[0].id;

      this.camera = new Html5QrcodeScanner(
        "reader",
        {
          fps: 10,
          qrbox: 250,
          rememberLastUsedCamera: true
        },
        false
      );

      this.camera.render(
        (decodedText) => {
          this.handleQRScan(decodedText);
        },
        () => {}
      );

      // troca automaticamente pra câmera escolhida
      setTimeout(() => {

        const cameraSelect =
          document.querySelector(
            "#reader__camera_selection"
          );

        if (cameraSelect) {

          cameraSelect.value = cameraId;

          cameraSelect.dispatchEvent(
            new Event("change")
          );

        }

      }, 500);
    }, 2000);
  };

  // handleStartCam = () => {
    
  // };

  render() {
    let empresa = localStorage.getItem("@comer-aqui/empresa");
    empresa = JSON.parse(empresa);
    let taxaDeServico = empresa.vlTaxaentrega;
    //let { taxaDeServico } = this.state;

    return (
      <div style={{position: "relative", height: "100%"}}>
      <div style={{height: "100%"}}>
        <Header apenasLogo={true} />

        <Popup
          open={this.state.show}
          modal
          contentStyle={{
            maxWidth: "100%",
            width: "90%",
          }}
          onClose={() => {
            this.setState({ show: false });
          }}
        >
          <div className="py-3 row m-0">
            <div className="col-12">
              <h6 className="m-0">
                Selecione os produtos que deseja receber agora na mesa
              </h6>
            </div>
            <div className="col-md-12 p-0 mt-2 mb-3">
              <ul className="list-group">
                {this.props.cart.items.length > 0 &&
                  this.state.existInVerificaimpressora ? (
                  this.props.cart.items.map(
                    (item) =>
                      item.inVerificaimpressora && (
                        <div key={`${item.id}-${item.product.id}`}>
                          <div className="row m-0">
                            <div className="col-md-12">
                              <label
                                className="d-flex align-items-center label-add-complement"
                                htmlFor={item.product.id}
                              >
                                <div className="check">
                                  <input
                                    className="form-check-input-product"
                                    type="checkbox"
                                    id={item.product.id}
                                    data-id={item.product.id}
                                    name={item.product.id}
                                    onClick={(e) => {
                                      this.checkVerificaimpressora(item, e);
                                    }}
                                    style={{ marginTop: "2px" }}
                                  />
                                  <span
                                    className="ml-2"
                                    htmlFor={item.product.id}
                                  >
                                    {item.product.quantity > 0 && (
                                      <span className="item-quantity">
                                        {item.product.quantity}
                                      </span>
                                    )}
                                    {item.product.quantity > 0 && (
                                      <span> x </span>
                                    )}
                                    <span className="item-description">
                                      {item.product.dename}
                                    </span>
                                    {item.product.name}
                                  </span>
                                </div>
                              </label>
                            </div>
                          </div>
                        </div>
                      )
                  )
                ) : (
                  <span className="title-complement-not-found">
                    {" "}
                    Nenhum produto adicionado :({" "}
                  </span>
                )}
              </ul>
            </div>
            <div className="col-md-12 col-xl-12 col-sm-12 col-12 text-center">
              <button
                className="btn btn-circle btn-block btn-danger"
                onClick={() => this.setState({ show: false })}
              >
                CANCELAR <FaTimesCircle />
              </button>
              <button
                className="btn btn-block btn-success mt-2"
                onClick={() => {
                  this.handleFinalizeOrder(this);
                  this.setState({ isButtonDisabled: true });
                }}
                disabled={this.state.isButtonDisabled}
                style={{ opacity: this.state.isButtonDisabled ? 0.5 : 1 }}
              >
                FINALIZAR PEDIDO <FaCheck />
              </button>
            </div>
          </div>
        </Popup>
        <div className="order-title">
          <span className="title-order-preview">Resumo do pedido</span>
        </div>
        <div
          className={`order-products ${!this.props.cart.items.length > 0 &&
            "d-flex align-items-center h-100"
            }`}
        >
          {this.props.cart.items.length > 0 ? (
            this.props.cart.items.map((item, key) => (
              <ItemCart key={key} item={item} />
            ))
          ) : (
            <h6 className="text-center">
              Nenhum item adicionado ao carrinho :(
            </h6>
          )}
        </div>
        {this.state.showPopMesa && (
          <Popup
            open={this.state.showPopMesa}
            modal
            contentStyle={{
              maxWidth: "500px",
              width: "90%",
            }}
            onClose={() => {
              this.setState({
                disable: false,
              });
              this.setState({ showPopMesa: false });
            }}
          >
            <div
              className="container-sm pt-4 pb-4 row m-0 "
              style={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
              }}
            >
              <div
                className=""
                style={{
                  flex: 1,
                  width: "100%",
                  justifyContent: "end",
                  marginBottom: "20px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <button
                  className="btn btn-circle btn-danger"
                  onClick={() => {
                    this.setState({ showPopMesa: false });
                  }}
                >
                  Fechar <FaTimesCircle />
                </button>
              </div>
              <div
                className=""
                style={{ display: "flex", flexDirection: "column" }}
              >
                <h6>Em qual mesa você está?</h6>
                <input
                  type="number"
                  ref="thing"
                  value={this.state.local}
                  placeholder="Número da mesa"
                  onChange={(e) => {
                    if (e.target.value === "") {
                      this.setState({ local: null });
                    } else {
                      this.setState({ local: e.target.value });
                    }
                  }}
                  className="form-control"
                  style={{ width: "100%" }}
                />
              </div>
              <div
                className=""
                style={{
                  flex: 1,
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <button
                  className="btn  btn-block  btn-success"
                  onClick={this.verifyValueMesa}
                  disabled={this.state.local === null}
                >
                  Confirmar <FaCheck />
                </button>
              </div>
            </div>
          </Popup>
        )}

        {this.state.showPopQRCodeMesa && (
          <>
            <Popup
              open={this.state.showPopQRCodeMesa}
              modal
              contentStyle={{
                maxWidth: "500px",
                width: "90%",
                position: "relative",
                height: this.state.showPopAlert ? "fit-content" : "80%",
              }}
              onClose={() => {
                this.setState({
                  disable: false,
                });
                this.setState({ showPopQRCodeMesa: false });
                this.setState({ onStartCam: false });
                this.setState({ showPopAlert: true });
              }}
            >
              {this.state.showPopAlert ? (
                <>
                  <div
                    className=""
                    style={{
                      flex: 1,
                      marginTop: "5px",
                      display: "flex",
                      padding: "40px",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <div style={{ padding: "20px", fontSize: "22px" }}>
                      <span>Por favor, leia o QrCode da comanda</span>
                    </div>
                    <div
                      className=""
                      style={{
                        flex: 1,
                        marginTop: "5px",
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <button
                        className="btn btn-circle btn-secondary "
                        onClick={() => {
                          this.setState({ showPopQRCodeMesa: false });
                          this.setState({ onStartCam: false });
                        }}
                      >
                        Cancelar
                      </button>
                      <button
                          className="btn btn-circle btn-primary "
                          onClick={() => {
                            this.setState({
                              showPopAlert: false,
                            });
                            this.abrirCamera();
                          }}
                        >
                          {/* Ler QRCode <FaCamera style={{ marginLeft: "5px" }} /> */}
                          Ler QRCode
                        </button>
                    </div>
                  </div>
                </>
              ) : (
                <div
                  className="container-sm pt-4 pb-4 row m-0 "
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                  }}
                >
                  <div
                    className=""
                    style={{
                      flex: 1,
                      width: "100%",
                      justifyContent: "end",
                      marginBottom: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <button
                      className="btn btn-circle btn-danger"
                      onClick={() => {
                        this.setState({ showPopQRCodeMesa: false });
                        this.setState({ showPopAlert: true });
                        this.setState({ onStartCam: false });
                      }}
                    >
                      Fechar <FaTimesCircle />
                    </button>
                  </div>

                  <div
                    className=""
                    id="reader"
                    style={{
                      flex: 1,
                      marginTop: "5px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "286px",
                      }}
                    >
                      {!this.state.onStartCam && (
                          <div class="skeleton">
                            <BsCameraFill></BsCameraFill>
                            <span style={{ fontSize: "20px" }}>
                              Carregando câmera...
                            </span>
                          </div>
                        )}

                    </div>
                  </div>
                </div>
              )}
            </Popup>
          </>
        )}
        </div>
        <div className="fixed-bottom action-bottom" height="auto">
          <div className="more-items">
            <button onClick={this.handleMoreItems}>
              Escolher mais <FaPlus />
            </button>
          </div>
          <div
            className="container order-totals"
            style={{ marginTop: "4px", marginBottom: "4px" }}
          >
            {taxaDeServico > 0 && (
              <>
                <span className="title-totals">Totais</span>
                <div className="wrapp-service-value">
                  <span className="title-service-value">Taxa de serviço</span>
                  <span className="service-value">
                    {Currency.formatterValue.format(taxaDeServico)}*
                  </span>
                </div>
              </>
            )}
            <div className="wrapp-amount">
              <span className="title-amount">Total</span>
              <span className="amount">
                {Currency.formatterValue.format(
                  parseFloat(this.props.cart.totalprice) +
                  parseFloat(taxaDeServico)
                )}
              </span>
            </div>
          </div>
          <div className="actions">
            <button onClick={this.handleFinalizeOrderByTable}>
              Finalizar pedido <FaCheck />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ cart: state.cart });

const mapDispatchToProps = { ...CartCreator, ...ProductCreator };

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
